import clsx from "clsx";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "status" | "classification" | "default";
  color?: string;
  className?: string;
}

export function Badge({
  children,
  variant = "default",
  color,
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        {
          "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200":
            variant === "default",
        },
        className,
      )}
      style={
        color
          ? {
              backgroundColor: `${color}20`,
              color: color,
              border: `1px solid ${color}40`,
            }
          : undefined
      }
    >
      {children}
    </span>
  );
}

interface StatusDotProps {
  color: string;
  className?: string;
}

export function StatusDot({ color, className }: StatusDotProps) {
  return (
    <span
      className={clsx("inline-block w-2 h-2 rounded-full", className)}
      style={{ backgroundColor: color }}
    />
  );
}
